
<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Demande d'inscription" />
            <DemandeInscription />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'

import FooterComp from '../Layouts/FooterComp'
import DemandeInscription from '../DemandeInscription/DemandeInscription.vue';

export default {
    name: 'DemandeInscriptionPage',
    components: {
        NavBar,
        PageTitle,
        DemandeInscription,
        FooterComp,
    }
}
</script>